export default __webpack_public_path__ + "static/media/block.36393147.png";